import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Alert, Box} from 'views/components';
import {translate} from 'views/module';

import Schedule from 'views/scenes/caregiver/detail/caregiver_scenes/caregiver_feed/schedule/Schedule';

import backend from 'utils/backend';

// The caregiver view's calendar, fed from Loom. Loom reads shifts by legacy RN.
const LoomCaregiverSchedule = (props) => {
  const {caregiverRn, refresh} = props;
  const progressWrap = props.statusProgressWrap;

  const [scheduleEvents, setScheduleEvents] = React.useState({});

  const caregiverBackend = React.useMemo(() => ({
    schedule: {
      loadMonthlyEvents: (byMonths, loadCaregiverUpdates, options = {}) => {
        progressWrap(async () => {
          const output = await backend.loom.schedule.loadCaregiverMonths(caregiverRn, byMonths, loadCaregiverUpdates, options);
          const events = output.events.reduce((result, event) => ({
            ...result,
            [event.eventRn]: event,
          }), {});

          setScheduleEvents((current) => ({...current, ...events}));
        }, {debugString: 'LOOM_CAREGIVER_SCHEDULE_LOAD_EVENTS'});
      },
    },
  }), [caregiverRn, progressWrap]);

  if (!caregiverRn) {
    return (
      <Box sx={{p: 2}}>
        <Alert severity='info'>{translate('caregiver.LoomCaregiverDetail.Schedule.NoLegacyRn')}</Alert>
      </Box>
    );
  }

  return (
    <Schedule
      refresh={refresh}
      caregiverScheduleEvents={scheduleEvents}
      caregiverBackend={caregiverBackend}
    />
  );
};
LoomCaregiverSchedule.propTypes = {
  caregiverRn: PropTypes.string,
  refresh: PropTypes.number.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(LoomCaregiverSchedule));
